import { environment } from "./config/environment";
export const data = {
  USER_POOL_ID: environment.cognitoUserPoolId,
  APP_CLIENT_ID: environment.cognitoAppClientId,
  REGION: environment.cognitoRegion,
};
